import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  mediaFadeRevealAnimation,
  type SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const videoBlockRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaFadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0)
  }

  return () => {
    timeline.kill()

    mediaAnimation?.revert()
  }
}
